export default __webpack_public_path__ + "static/AeonikRegular-af74cef5aace521863b41c6cbea945a4.woff";